import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import type { AutoTxId } from "../../../../api/types";
import { TransactionList } from "../../../../components/TransactionList";

export type RuleAppliedModalProps = {
  open: boolean;
  ruleId: AutoTxId | null;
  ruleName?: string | null;
  /**
   * Optional banner shown above the transactions list — used by the delete
   * error path to explain why the dialog is open.
   */
  intro?: string;
  onClose: () => void;
};

/**
 * The transactions this rule has been **applied to** — the recorded edits that
 * cite it, not what its condition would match.
 *
 * The two used to share a name, and a freshly written rule listing nothing
 * here read as a broken matcher rather than a rule that had simply never run.
 * What the condition matches is {@link AutoTransactionMatchesDialog}.
 */
export const RuleAppliedModal = ({
  open,
  ruleId,
  ruleName,
  intro,
  onClose,
}: RuleAppliedModalProps) => (
  <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
    <DialogTitle>
      {ruleName
        ? `Transactions "${ruleName}" has been applied to`
        : "Transactions this rule has been applied to"}
    </DialogTitle>
    <DialogContent>
      {intro && <Box sx={{ mb: 2 }}>{intro}</Box>}
      {ruleId && (
        <Box sx={{ height: "60vh", overflow: "auto" }}>
          <TransactionList
            filters={{
              startDate: null,
              endDate: null,
              autoTransactionId: [ruleId],
              limit: 100,
              cursor: null,
              sort: "dateDesc",
            }}
          />
        </Box>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Close</Button>
    </DialogActions>
  </Dialog>
);
